import React, {useState} from 'react';
import './SearchBar.css';

import { FaSearch, FaTimes } from 'react-icons/fa';

const SearchBar = ({ setResults }) => {

  const [input, setInput ] = useState('');
  const [loading, setLoading] = useState(false);
  const [close, setClose] = useState(false);


  const fetchData = async (value) => {

      setLoading(true);
      setClose(false);

    console.log(value);
    
    try {
      const response = await fetch('https://dashboard.tiktaka.com/api/users', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({search : value})

      });

      const data = await response.json();

      console.log(data);
      

      if (response.ok) {
            setResults(data.users);
            console.log(data.users);
            // return data.users;

      }else {
            console.log(data.message);
            
        }

    } catch (error) {
      console.error(error);
      alert('⚠️ حصل خطأ في الاتصال بالسيرفر');
      alert(error);
    } finally {
    setLoading(false);
    setClose(true);

  }

    // fetch('https://jsonplaceholder.typicode.com/users').then((response) => response.json()).then(json => {
    // fetch('https://dashboard.tiktaka.com/api/users').then((response) => response.json()).then(json => {
    //   const results = json.filter((user) => {
        
    //     console.log(123333333);
        

    //     return (
    //     user && 
    //     user.name && 
    //     user.name.toLowerCase().includes(value)
    //   );

    //   });
    //   setResults(results);
    // });

  };

  const handleChange = (value) => {    
    setInput(value);
    fetchData(value);
  };


  return (
<div className='inputWrapper'> 
  <FaSearch id='search-icon' />

  <input
    placeholder='Search'
    value={input}
    className="search-input"
    onChange={(e) => handleChange(e.target.value)}
  />

    {loading && <div className="loader"></div>}


  {input && close && (
    <button
      className="clear-button"
      onClick={() => handleChange('')}
    >
      <FaTimes />
    </button>
  )}
</div>
  );
};

export default SearchBar;

